module.exports = __webpack_public_path__ + "static/img/fan.ce11699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fan/fan.png
// module id = HoBm
// module chunks = 1